import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import SocieteAndUserService from "../../../services/societeAndUser";
import UtilsUrl from "../../../utils/UtilsUrl";
import SocieteService from "../../../services/SocieteService";
import ContactTable from "./ContactTable";
const theSocieteIs = [
  { label: " ", value: " " },
  { label: "FOURNISSEUR", value: "Fournisseur" },
  { label: "CLIENT", value: "Client" },
];

const codeCategorie = [
  { id: "1", value: "P" },
  { id: "2", value: "M" },
  { id: "3", value: "C" },
];

const type = [
  { id: "1", value: "Personne physique" },
  { id: "2", value: "Personne morale" },
];

const typeTVA = [
  { id: "NORMAL", value: "Normale" },
  { id: "EXPORTATRICE", value: "Exportatrice" },
];
const typeSoceite = [{ id: "PARTNER", value: "Partenaire" }];
const UpdateClientSociete = () => {
  const navigate = useNavigate();
  const [showElement, setShowElement] = useState(
    JSON.parse(localStorage.getItem("status"))
  );

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [societeTitle, setSocieteTitle] = useState("");
  const [societeMatricule, setSocieteMatricule] = useState("");
  const [societeAdress, setSocieteAdress] = useState("");
  const [societeTVACode, setSocieteTVACode] = useState("");
  const [societeTimbre, setSocieteTimbre] = useState();
  const [societeTVAValue, setSocieteTVAValue] = useState();
  const [societeNumberEtabSecondaire, setSocieteNumberEtabSecondaire] =
    useState("");
  const [societeEmail, setSocieteEmail] = useState("");
  const [societeCode, setSocieteCode] = useState("");
  const [societePhoneNumbre, setSocietePhoneNumbre] = useState("");

  const [societeLabel, setSocieteLabel] = useState(" ");
  const [codeCategorieValue, setCodeCategorieValue] = useState("P");
  const [codeCategorieActuel, setCodeCategorieActuel] = useState();
  const [typeSocieteActuel, setTypeSocieteActuel] = useState();

  const [typeSocieteFinal, setTypeSocieteFinal] = useState("Personne physique");
  const [isCancel, setIsCancel] = useState(false);

  const [societeCodeCategorieName, setSocieteCodeCategorieName] = useState("");
  const [societeCodeCategories, setSocieteCodeCategories] =
    useState(codeCategorie);
  const inputC = useRef(null);

  const [societeTypeName, setSocieteTypeName] = useState("");
  const [societeTypes, setSocieteTypes] = useState(type);
  const soceiteTypeRef = useRef(null);

  const [societeTypeNameTwo, setSocieteTypeNameTwo] = useState("");
  const [societeTypesTwo, setSocieteTypesTwo] = useState(typeSoceite);
  const soceiteTypeTwoRef = useRef(null);

  const [societeTypeTvaName, setSocieteTypeTvaName] = useState("");
  const [societeTypesTva, setSocieteTypesTva] = useState(typeTVA);
  const soceiteTypeTVARef = useRef(null);

  const inputTvaValueRef = useRef(null);

  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [onConfirmAddSociete, setOnConfirmAddSociete] = useState(false);
  const [confirmSocieteModel, setConfirmSocieteModel] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [fileURL, setFileURL] = useState(null);
  const [listContacts, setListContacts] = useState([]);

  useEffect(() => {
    SocieteService.getSocietesContacts(
      getCurrentUserId(),
      localStorage.getItem("SocieteContactId")
    )
      .then((response) => {
        if (response.data.success) {
          setListContacts(response.data.success);
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
    SocieteAndUserService.getSocieteById(localStorage.getItem("SocieteContactId"))
      .then((response) => {
        console.log("getSocieteById", response.data.Societe);
        setSocieteTitle(response.data.Societe.title);
        setSocieteMatricule(response.data.Societe.matricule)
        setSocieteNumberEtabSecondaire(response.data.Societe.numberEtabSecondaire)
        setSocieteTimbre(response.data.Societe.timbre)
        setSocieteEmail(response.data.Societe.email)
        setSocieteCode(response.data.Societe.code || "")
        setSocietePhoneNumbre(response.data.Societe.numPhone)
        setCodeCategorieActuel(response.data.Societe.codeCategorie)
        setSocieteAdress(response.data.Societe.adresse)
        setSocieteTVAValue(response.data.Societe.tva)
        setTypeSocieteActuel(response.data.Societe.typeTVA)
        setSocieteTVACode(response.data.Societe.codeTVA)
        // setFileURL(response.data.Societe.fileUrl)
       
      })
      .catch((error) => {
        setErrorAlertText("Erreur: " + error);
        setOpenErrorAlert(true);
      });
  }, []);

  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  const onChangeSocieteNumberEtabSecondaire = (event) => {
    setSocieteNumberEtabSecondaire(event.target.value);
  };

  const onChangeSocieteTimbre = (event) => {
    setSocieteTimbre(event.target.value);
  };

  const onChangeSocieteEmail = (event) => {
    setSocieteEmail(event.target.value);
  };
  const onChangeSocietePhoneNumber = (event) => {
    setSocietePhoneNumbre(event.target.value);
  };

  const onChangeSocieteAdress = (event) => {
    setSocieteAdress(event.target.value);
  };

  const onChangeSocieteTVACode = (event) => {
    setSocieteTVACode(event.target.value);
  };
  const changeTypeTVA = (event) => {
    let typeTvaElement = event.target.value;

    if (event.target.value === "Exportatrice") {
      inputTvaValueRef.current.value = 0;
      inputTvaValueRef.current.disabled = true;
      setSocieteTVAValue(0);
    } else {
      inputTvaValueRef.current.disabled = false;
    }

    setSocieteTypeTvaName({ typeTvaElement });
  };
  const initializeTypeTva = () => {
    setSocieteTypeTvaName("");
    soceiteTypeTVARef.current.value = "";
  };
  const onChangeSocieteTvaValue = (event) => {
    setSocieteTVAValue(event.target.value);
  };
  const onUploadImageHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      const file = e.target.files[0];

      setFile(file);
      setFileName(e.target.files[0].name);
    }
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onConfirmAddSocieteHandler = () => {
      if (societeLabel === "") {
      setErrorAlertText("Erreur :le premier champ est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeTitle === "") {
      setErrorAlertText("Erreur :le champ titre  est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeMatricule === "") {
      setErrorAlertText("Erreur :le champ matricule  est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeNumberEtabSecondaire === "") {
      setErrorAlertText(
        "Erreur :le champ  nombre d'établissements secondaires  est vide ! "
      );
      setOpenErrorAlert(true);
    } else if (societeTimbre === 0) {
      setErrorAlertText("Erreur :le champ  timbre est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeEmail === "") {
      setErrorAlertText("Erreur :le champ email est vide ! ");
      setOpenErrorAlert(true);
    } else if (societePhoneNumbre === "") {
      setErrorAlertText("Erreur :le champ télephone est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeAdress === "") {
      setErrorAlertText("Erreur :le champ adresse est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeTVACode === "") {
      setErrorAlertText("Erreur :le champ code TVA   est vide ! ");
      setOpenErrorAlert(true);
    } else if (
      societeTypeTvaName.typeTvaElement === "" ||
      (societeTypeTvaName.typeTvaElement === "") === undefined
    ) {
      setErrorAlertText("Erreur :le champ type de TVA  est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeTVAValue < 0) {
      setErrorAlertText("Erreur :le champ type de TVA ( % )  est vide ! ");
      setOpenErrorAlert(true);
    } else {
      let confirmModel = {
        title: societeTitle,
        matricule: societeMatricule,
        adresse: societeAdress,
        idUserCreation: getCurrentUserId(),
        idSociete:localStorage.getItem("SocieteContactId"),
        typeSociete: codeCategorieValue === "C" ? typeSocieteFinal : "",
        codeTVA: societeTVACode,
        codeCategorie: codeCategorieValue,
        numberEtabSecondaire: societeNumberEtabSecondaire,
        email: societeEmail,
        code: societeCode.trim(),
        numPhone: societePhoneNumbre,
        typeTVA: societeTypeTvaName,
        timbre: societeTimbre,
        tva: societeTVAValue,
        typeClient: societeLabel,
        fileUrl:null
        // file: file,
      };
      console.log("file",file)
      if (file != null) {
        const uploadData = new FormData();
        uploadData.append("picture", file);

        UploadAndDownloadService.uploadFile(
          "/retail/uploadFile/uploadFile/SocietePicture",
          uploadData
        )
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              confirmModel.fileUrl = response.data.success;
              console.log("update",JSON.stringify(confirmModel))

              SocieteAndUserService.updateSociete(confirmModel)
                .then((res) => {
                  if (Object.keys(res.data)[0] === "societeSuccess") {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                      navigate(`/tiers`);
                    }, 2000);
                  }
                })
                .catch(() => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur : il ya un probléme de connection");
                });
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur  ");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          });
      } else {
        console.log("update",JSON.stringify(confirmModel))

        SocieteAndUserService.updateSociete(confirmModel)
          .then((res) => {
            if (Object.keys(res.data)[0] === "societeSuccess") {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succées");
              setTimeout(() => {
                navigate(`/tiers`);
              }, 2000);
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          });
      }
    }
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  function logoFormatter() {
    if(fileURL!==null){
        return (
            <span>
              <img
                alt="Remy Sharp"
                src={UtilsUrl.fileRetailURL() + fileURL}
                // ref={(ref) => {
                //   myRefs.current[index] = ref;
                // }}
                class="rounded-circle"
                style={{ width: "50px", height: "50px" }}
              ></img>
            </span>
          );
    }else{
        return <span></span>
    }
    
  }
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Modifier tiers</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Modifier un tiers</h5>
                </div>
                <div className="card-body">
                  <div className="row" style={{ marginTop: 10 }}>
                    <div className="col-sm-12">
                      <div className="form-group">
                        {logoFormatter()}
                        <div className="row">

                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">Titre: {societeTitle}</label>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">Matricule: {societeMatricule}</label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">
                                Nombre d'établissements secondaires:
                              </label>
                              <input
                                defaultValue={societeNumberEtabSecondaire}
                                onChange={onChangeSocieteNumberEtabSecondaire}
                                type="text"
                                id="inputName"
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">Timbre:</label>
                              <input
                                defaultValue={societeTimbre}
                                // placeholder={societeTimbre}
                                onChange={onChangeSocieteTimbre}
                                type="number"
                                min="0"
                                id="inputName"
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">Email:</label>
                              <input
                              defaultValue={societeEmail}
                                // placeholder={societeEmail}
                                onChange={onChangeSocieteEmail}
                                type="email"
                                id="inputName"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="societeCode">Code (facultatif):</label>
                              <input
                                value={societeCode}
                                onChange={(event) => setSocieteCode(event.target.value)}
                                type="text"
                                id="societeCode"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">Télephone:</label>
                              <input
                                defaultValue={societePhoneNumbre}
                                onChange={onChangeSocietePhoneNumber}
                                type="text"
                                id="inputName"
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">Adresse:</label>
                              <input
                                defaultValue={societeAdress}
                                onChange={onChangeSocieteAdress}
                                type="text"
                                id="inputName"
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <div>
                                <label>Code de catégorie: {codeCategorieActuel}</label>
                                <select
                                  value={codeCategorieValue || null}
                                  onChange={(e) =>
                                    setCodeCategorieValue(e.target.value)
                                  }
                                  className="form-control select2"
                                  style={{ width: "100%" }}
                                >
                                  {codeCategorie.map((element, index) => (
                                    <option
                                      key={element.id}
                                      value={element.value}
                                    >
                                      {element.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            {codeCategorieValue === "C" && (
                              <div className="form-group">
                                <div>
                                  <label>Type de société: </label>
                                  <select
                                    value={typeSocieteFinal || null}
                                    onChange={(e) =>
                                      setTypeSocieteFinal(e.target.value)
                                    }
                                    className="form-control select2"
                                    style={{ width: "100%" }}
                                  >
                                    {type.map((element, index) => (
                                      <option
                                        key={element.id}
                                        value={element.value}
                                      >
                                        {element.value}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">Code TVA:</label>
                              <input
                                defaultValue={societeTVACode}
                                onChange={onChangeSocieteTVACode}
                                type="text"
                                id="inputName"
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Société: {typeSocieteActuel}</label>
                            
                              <input
                                class="form-control"
                                data-value={societeTypeTvaName?.value}
                                value={societeTypeTvaName?.value}
                                type="text"
                                list="dataFour"
                                ref={soceiteTypeTVARef}
                                onChange={changeTypeTVA}
                                onClick={initializeTypeTva}
                              />

                              <datalist id="dataFour">
                                {societeTypesTva.map((typeTvaElem, index) => (
                                  <option
                                    key={index}
                                    value={typeTvaElem.value}
                                  ></option>
                                ))}
                              </datalist>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label htmlFor="inputName">TVA {"( % )"}:</label>
                              <input
                                defaultValue={societeTVAValue}
                                onChange={onChangeSocieteTvaValue}
                                type="number"
                                ref={inputTvaValueRef}
                                min="0"
                                id="inputName"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div
                                class="input-group  sm-white border"
                                style={{ marginTop: 100 }}
                              >
                                <input
                                  id="upload"
                                  type="file"
                                  accept=".jpg, .jpeg, .png"
                                  className="form-control border-0"
                                  onChange={onUploadImageHandler}
                                />

                                <label
                                  id="upload-label"
                                  for="upload"
                                  class="font-weight-light text-muted"
                                >
                                  {fileName}
                                </label>
                                <div class="input-group-append">
                                  <label
                                    for="upload"
                                    class="btn btn-light m-0 rounded-pill px-4"
                                  >
                                    {" "}
                                    <i class="fa fa-cloud-upload mr-2 text-muted"></i>
                                    <small class="text-uppercase font-weight-bold text-muted">
                                      Choisir une image
                                    </small>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div
                                class="image-area"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                {fileDataURL ? (
                                  <img
                                    id="imageResult"
                                    src={fileDataURL}
                                    alt
                                    style={{ height: 197, width: 620 }}
                                    className="img-fluid rounded shadow-sm mx-auto d-block"
                                  />
                                ) : (
                                  <img
                                    style={{ marginTop: 180 }}
                                    id="imageResult"
                                    src="#"
                                    alt
                                    className="img-fluid rounded shadow-sm mx-auto d-block"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-dark float-right"
                    onClick={onConfirmAddSocieteHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {listContacts.length !== 0 && (
        <section className="content ">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <ContactTable listClients={listContacts} />
              </div>
            </div>
          </div>
        </section>
      )}
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default UpdateClientSociete;
